{
  "adminPanel": {
    "licenseRequests": {
      "responseFileHint": "Lisans için oluşturulan lisans dosyasını indirmek istiyorsanız, onaylama işleminden sonra IssuesLicenses veya MyLicenseRequests sekmesine gidin."
    }
  },
  "auth": {
    "agree": "Kabul ediyorum",
    "createAccount": "Hesap oluştur",
    "createNewAccount": "Yeni Hesap Oluştur",
    "email": "E-posta",
    "login": "Giriş yap",
    "password": "Şifre",
    "recover_password": "Şifremi kurtar",
    "sign_up": "Kayıt ol",
    "keep_logged_in": "Bu cihazda oturum açık tut",
    "termsOfUse": "Kullanım Koşulları.",
    "reset_password": "Şifreyi sıfırla",
    "login_title": "Giriş yap",
    "no_account": "Hesabın yok mu?",
    "create_account": "Hesap oluştur",
    "email_or_username": "E-posta veya Kullanıcı Adı",
    "forgot_password": "Şifremi unuttum?",
    "forgot_password_title": "Şifrenizi mi unuttunuz?",
    "forgot_password_description": "E-posta adresinizi girin, size şifrenizi sıfırlamanız için talimatları gönderelim.",
    "email_not_found": "Girilen e-posta adresi sistemimizde bulunamadı. Lütfen adresi kontrol edip tekrar deneyiniz.",
    "send_mail_success": "Şifre sıfırlama bağlantısı e-posta adresinize başarıyla gönderildi.",
    "send_mail_error": "Şifre sıfırlama e-postası gönderilemedi. Lütfen daha sonra tekrar deneyiniz.",
    "send_reset_email": "Sıfırlama E-postası Gönder",
    "back_to_login": "Giriş sayfasına dön",
    "password_reset_request_sent": "Şifre sıfırlama talimatları e-postanıza gönderildi",
    "need_help": "Yardıma İhtiyacınız Var?",
    "contact_support_message": "Şifre sıfırlama konusunda yardım için destek ekibimizle iletişime geçin:",
    "check_email_title": "Şifre Sıfırlama Desteği",
    "check_email_description": "Şifre sıfırlama yardımı için aşağıdaki bilgileri kullanarak destek ekibimizle iletişime geçin. Ekibimiz hesabınıza yeniden erişim sağlamanızda size yardımcı olacaktır.",
    "need_assistance": "Yardıma İhtiyacınız Var?",
    "contact_support_reset_message": "Şifre sıfırlama konusunda yardım için destek ekibimizle iletişime geçin:",
    "visit_for_support": "Destek ve yardım için web sitemizi ziyaret edin",
    "login_success": "Başarıyla giriş yaptınız",
    "signup_title": "Kayıt ol",
    "have_account": "Hesabın var mı?",
    "first_name": "Ad",
    "last_name": "Soyad",
    "username": "Kullanıcı Adı",
    "username_optional": "Kullanıcı Adı (isteğe bağlı, belirtilmezse e-posta kullanılacak)",
    "repeat_password": "Şifreyi Tekrarla",
    "signup_success": "Başarıyla kayıt oldunuz! Şimdi giriş yapabilirsiniz.",
    "validation": {
      "required": {
        "first_name": "Ad alanı zorunludur",
        "last_name": "Soyad alanı zorunludur",
        "email": "E-posta alanı zorunludur",
        "password": "Şifre alanı zorunludur",
        "repeat_password": "Şifre tekrarı alanı zorunludur"
      },
      "email": "Geçerli bir e-posta adresi giriniz",
      "password": {
        "length": "Şifre en az 8 karakter uzunluğunda olmalıdır",
        "letter": "Şifre en az bir harf içermelidir",
        "number": "Şifre en az bir rakam içermelidir",
        "special": "Şifre en az bir özel karakter içermelidir",
        "match": "Şifreler eşleşmiyor"
      }
    }
  },
  "billing": {
    "comingSoon": {
      "title": "Faturalandırma Sistemi",
      "subtitle": "Kapsamlı faturalandırma ve faturalama sistemimiz şu anda geliştirilme aşamasındadır ve yakında kullanıma sunulacaktır."
    }
  },
  "404": {
    "title": "Bu sayfa balık tutmaya gitti.",
    "text": "Eğer bunun doğru olmadığını düşünüyorsanız, lütfen bize mesaj gönderin: ",
    "back_button": "Dashboarda dön"
  },
  "typography": {
    "primary": "Birincil metin stilleri",
    "secondary": "İkincil metin stilleri"
  },
  "dashboard": {
    "versions": "Sürümler",
    "setupRemoteConnections": "Uzak Bağlantıları Ayarla",
    "currentVisitors": "Mevcut Ziyaretçiler",
    "navigationLayout": "gezinme düzeni",
    "topBarButton": "Üst Çubuk",
    "sideBarButton": "Yan Çubuk",
    "welcome": {
      "title": "Tekrar hoş geldiniz",
      "subtitle": "RAKORT tarafından desteklenen güvenli lisans yönetim platformunuz.",
      "defaultUser": "Kullanıcı"
    },
    "features": {
      "licenseManagement": {
        "title": "Lisans Yönetim Sistemi",
        "description": "Kapsamlı çevrimiçi ve çevrimdışı lisans doğrulama ve takibi"
      },
      "dataProtection": {
        "title": "Kurumsal Veri Koruması",
        "description": "Şirketinizin değerli fikri mülkiyetini koruma"
      },
      "compliance": {
        "title": "Uyumluluk ve Yönetişim",
        "description": "Mevzuat uyumluluğu ve lisans kullanım politikalarının sağlanması"
      },
      "assetManagement": {
        "title": "Varlık Yönetimi",
        "description": "Dijital varlıklar ve lisanslar üzerinde tam görünürlük ve kontrol"
      },
      "status": "Operasyonel"
    },
    "licenseTypes": {
      "online": {
        "title": "Çevrimiçi Lisanslar",
        "description": "Bulut tabanlı lisans doğrulama",
        "status": "Çevrimiçi Destek"
      },
      "offline": {
        "title": "Çevrimdışı Lisanslar",
        "description": "İnternet erişimi olmadan lisans doğrulama",
        "status": "Çevrimdışı Destek"
      },
      "enterprise": {
        "title": "Kurumsal Koruma",
        "description": "Şirket veri varlıklarının güvenliğini sağlama",
        "status": "Tam Koruma"
      }
    },
    "compliance": {
      "title": "Kurumsal Lisans Yönetimi ve Güvenlik",
      "items": {
        "onlineValidation": "Çevrimiçi Lisans Doğrulama",
        "offlineProtection": "Çevrimdışı Lisans Koruması",
        "dataSecurity": "Kurumsal Veri Güvenliği",
        "assetProtection": "Şirket Varlık Koruması",
        "complianceManagement": "Uyumluluk Yönetimi",
        "riskAssessment": "Risk Değerlendirmesi ve Azaltma",
        "digitalRights": "Dijital Haklar Yönetimi",
        "intellectualProperty": "Fikri Mülkiyet Koruması"
      }
    }
  },
  "sidebar": {
    "buyLicense": "Lisans Satın Al"
  },
  "language": {
    "brazilian_portuguese": "Portekizce",
    "english": "İngilizce",
    "spanish": "İspanyolca",
    "simplified_chinese": "Basitleştirilmiş Çince",
    "persian": "Farsça",
    "turkish": "Türkçe"
  },
  "menu": {
    "auth": "Kimlik Doğrulama",
    "buttons": "Düğmeler",
    "timelines": "Zaman Çizelgeleri",
    "dashboard": "Dashboard",
    "billing": "Faturalandırma",
    "login": "Giriş",
    "preferences": "Hesap tercihleri",
    "payments": "Ödemeler",
    "settings": "Uygulama ayarları",
    "pricing-plans": "Fiyatlandırma planları",
    "payment-methods": "Ödeme yöntemleri",
    "signup": "Kayıt ol",
    "recover-password": "Şifremi kurtar",
    "recover-password-email": "Şifre kurtarma e-postası",
    "license-requests": "Lisans istekleri",
    "404": "404",
    "faq": "SSS",
    "threatIntelligence": "Tehdit İstihbaratı",
    "users": "Kullanıcılar",
    "projects": "Projeler",
    "template-plans": "Plan Şablonları",
    "resolutionCenter": "Çözüm Merkezi",
    "mySupportTickets": "Destek Taleplerim",
    "myLicenses": "Lisanslarım",
    "licenseRequests": "Lisans Talepleri",
    "purchasedLicenses": "Satın Alınan Lisanslar",
    "issuedLicenses": "Verilen Lisanslar",
    "manageFeatures": "Özellik Yönetimi",
    "manageServices": "Servis Yönetimi",
    "logMonitor": "Log İzleme",
    "mfaAuthenticator": "MFA Doğrulayıcı",
    "updates": "Güncellemeler"
  },
  "messages": {
    "all": "Tüm mesajları gör",
    "new": "{name} adlı kullanıcıdan yeni mesajlar",
    "mark_as_read": "Okundu Olarak İşaretle"
  },
  "navbar": {
    "messageUs": "Web geliştirme sorularınız için:",
    "repository": "GitHub Deposu"
  },
  "notifications": {
    "all": "Tüm bildirimleri gör",
    "less": "Daha az bildirim göster",
    "mark_as_read": "Okundu olarak işaretle",
    "sentMessage": "size bir mesaj gönderdi",
    "uploadedZip": "{type} ile yeni bir Zip dosyası yükledi",
    "startedTopic": "yeni bir konu başlattı",
    "noNotifications": {
      "title": "Bildirim yok",
      "message": "Hepsi tamam! Şu anda yeni bildirim bulunmuyor."
    },
    "types": {
      "licenseExpiry": "Lisans süresi dolma uyarıları",
      "licenseRequests": "Lisans talepleri",
      "systemAlerts": "Sistem uyarıları",
      "messaging": "Mesajlaşma",
      "supportTickets": "Destek talepleri",
      "securityAlerts": "Güvenlik uyarıları",
      "maintenanceUpdates": "Bakım güncellemeleri",
      "billingNotifications": "Fatura bildirimleri",
      "accountUpdates": "Hesap güncellemeleri",
      "newsAndUpdates": "Ürün haberleri ve güncellemeler"
    }
  },
  "user": {
    "language": "Dili değiştir",
    "logout": "Çıkış yap",
    "profile": "Profil",
    "settings": "Ayarlar",
    "billing": "Faturalandırma",
    "faq": "SSS",
    "helpAndSupport": "Yardım ve destek",
    "projects": "Projeler",
    "account": "Hesap",
    "explore": "Keşfet"
  },
  "faq": {
    "title": "Sık Sorulan Sorular",
    "popularQuestions": "Popüler Sorular",
    "categories": {
      "licenseManagement": {
        "name": "Lisans Yönetimi",
        "intro": "Lisans yönetimi ve aktivasyon süreçleri"
      },
      "networkSecurity": {
        "name": "Ağ Güvenliği",
        "intro": "Ağ güvenliği çözümleri ve yapılandırmaları"
      },
      "technicalSupport": {
        "name": "Teknik Destek",
        "intro": "Yardım alma ve teknik destek hizmetleri"
      },
      "enterpriseSolutions": {
        "name": "Kurumsal Çözümler",
        "intro": "Kurumsal seviye çözümler ve entegrasyonlar"
      },
      "training": {
        "name": "Eğitim ve Öğretim",
        "intro": "Profesyonel eğitim ve sertifikasyon programları"
      },
      "productInfo": {
        "name": "Ürün Bilgileri",
        "intro": "Ürünlerimiz ve özellikleri hakkında detaylar"
      },
      "installation": {
        "name": "Kurulum ve Yapılandırma",
        "intro": "Kurulum kılavuzları ve ilk yapılandırma"
      },
      "contact": {
        "name": "İletişim ve Satış",
        "intro": "Satış talepleri ve iletişim bilgileri"
      },
      "updates": {
        "name": "Güncellemeler ve Bakım",
        "intro": "Yazılım güncellemeleri ve sistem bakımı"
      }
    },
    "demo": {
      "title": "Sorularınız mı var?",
      "description": "Ücretsiz demo talep edin ve tüm sorularınızın uzmanlarımız tarafından yanıtlanmasını sağlayın.",
      "button": "Demo Talep Et",
      "modal": {
        "title": "Ücretsiz Demo Talep Et",
        "description": "Şimdi yerinizi ayırın ve olağanüstü yazılım çözümlerimizle inovasyonu ateşleyin! 🔥",
        "emailLabel": "E-posta",
        "submitButton": "Demo Talep Et",
        "emailRequired": "E-posta alanı gereklidir",
        "emailValid": "E-posta geçerli olmalıdır",
        "successTitle": "Demo Talebi Gönderildi!",
        "successMessage": "Uzmanlarımız en kısa sürede sizinle iletişime geçecek"
      }
    },
    "questions": {
      "whatIsFastNAC": {
        "title": "FastNAC nedir ve nasıl çalışır?",
        "content": {
          "intro": "FastNAC, Rakort tarafından geliştirilen yeni nesil ağ erişim kontrol (NAC) çözümüdür. Tamamen yerli ve milli teknolojilerle geliştirilmiştir."
        },
        "feature1": "Radius ve Agent entegrasyonu olmadan çalışabilen özgün teknoloji",
        "feature2": "Kurumsal ağınızda erişim kontrolünü tamamen elinizde tutmanızı sağlar",
        "feature3": "Ağ güvenliğinizi en üst seviyede tutarak yetkisiz erişimleri önler",
        "feature4": "Kolay kurulum ve yönetim arayüzü ile hızlı devreye alma"
      },
      "whatProducts": {
        "title": "Hangi ürünleriniz bulunuyor?",
        "content": {
          "intro": "Rakort Bilgi ve İletişim Teknolojileri olarak Ar-Ge faaliyetleri sonucunda geliştirdiğimiz ürünlerimiz:",
          "conclusion": "Tüm ürünlerimiz yerli ve milli teknolojilerle geliştirilmekte olup, kamu ve özel sektör ihtiyaçlarına yönelik özel çözümler sunmaktadır."
        }
      },
      "technicalSupport": {
        "title": "Teknik destek nasıl alabilirim?",
        "content": {
          "intro": "Rakort olarak müşterilerimize kapsamlı teknik destek hizmetleri sunmaktayız:",
          "conclusion": "Hizmet Merkezi kapsamında yazılım, donanım ve telekomünikasyon çözümleri için yüksek SLA şartlarını sağlayacak teknik destek hizmetleri sunmaktayız."
        }
      },
      "trainingServices": {
        "title": "Eğitim hizmetleriniz nelerdir?",
        "content": {
          "intro": "Rakort olarak ağ teknolojileri konusunda profesyonel eğitim hizmetleri sunmaktayız:",
          "instructors": "Konusunda uzmanlaşmış eğitmenlerimiz, yenilikleri ve gelişmeleri takip eden güncel müfredatlarla profesyonel eğitim hizmeti sunmaktadır.",
          "contact": "Eğitim talebiniz için info\\u0040rakort.com adresine veya 0850 460 10 58 numaralı telefona başvurabilirsiniz."
        }
      },
      "licenseManagement": {
        "title": "Lisans yönetimi nasıl çalışır?",
        "content": {
          "intro": "Lisans yönetim platformumuz çevrimiçi ve çevrimdışı lisans doğrulama teknolojileri ile güvenli çözümler sunar:",
          "conclusion": "Kurumsal yapınıza uygun lisans modeli seçimi ve entegrasyon konularında uzman ekibimizden destek alabilirsiniz."
        }
      },
      "contactInfo": {
        "title": "İletişim bilgileriniz nelerdir?",
        "content": {
          "intro": "Rakort Bilgi ve İletişim Teknolojileri Ltd. Şti. ile iletişim bilgilerimiz:",
          "contactHeader": "İletişim Bilgileri",
          "phoneLabel": "Telefon",
          "emailLabel": "E-posta",
          "addressLabel": "Adres",
          "contact": {
            "phone": "0850 460 10 58",
            "email": "info\\u0040rakort.com",
            "address": "Mustafa Kemal Mah. 2139 Cad. Ekim Plaza No: 2 Kat: 2 Daire: 11 Çankaya / Ankara"
          },
          "conclusion": "Çalışma saatlerimiz içerisinde sizlere en iyi hizmeti sunmak için buradayız. Projeleriniz için danışmanlık ve çözüm önerilerimiz için bizimle iletişime geçin."
        }
      }
    },
    "products": {
      "fastNAC": {
        "name": "FastNAC",
        "desc": "Yeni nesil ağ erişim kontrol sistemi"
      },
      "arkSpot": {
        "name": "ArkSpot",
        "desc": "Güvenli WiFi erişim yönetim çözümü"
      },
      "rakortCall": {
        "name": "RakortCall",
        "desc": "Kurumsal ses iletişim sistemleri"
      },
      "rakortLog": {
        "name": "RakortLog",
        "desc": "Ağ güvenliği ve log yönetim sistemi"
      },
      "racGuard": {
        "name": "RacGuard",
        "desc": "Geliştirilme aşamasında olan güvenlik çözümü"
      },
      "secration": {
        "name": "Secration",
        "desc": "Geliştirilme aşamasında olan güvenlik ürünü"
      }
    },
    "support": {
      "phone": {
        "type": "Telefon Desteği",
        "desc": "0850 460 10 58 numaralı telefon hattımızdan çalışma saatleri içerisinde destek alabilirsiniz"
      },
      "email": {
        "type": "E-posta Desteği",
        "desc": "info\\u0040rakort.com adresine detaylı sorularınızı iletebilirsiniz"
      },
      "remote": {
        "type": "Uzaktan Destek",
        "desc": "Gerekli durumlarda uzaktan bağlantı ile hızlı çözüm sağlıyoruz"
      },
      "onsite": {
        "type": "Yerinde Destek",
        "desc": "Kritik sistemler için yerinde teknik destek hizmeti veriyoruz"
      }
    },
    "training": {
      "product": {
        "type": "Ürün Eğitimleri",
        "desc": "FastNAC, ArkSpot, RakortCall ve diğer ürünlerimizin kullanımı hakkında detaylı eğitimler"
      },
      "security": {
        "type": "Ağ Güvenliği Eğitimleri",
        "desc": "Network security, firewall yönetimi ve güvenlik politikaları konularında uzman eğitimler"
      },
      "linux": {
        "type": "Linux/Unix Eğitimleri",
        "desc": "Sistem yönetimi, yapılandırma ve güvenlik konularında uzman eğitimler"
      },
      "custom": {
        "type": "Özel Çözüm Eğitimleri",
        "desc": "Müşteri ihtiyaçlarına özel geliştirilmiş eğitim programları"
      }
    },
    "license": {
      "online": {
        "type": "Çevrimiçi Lisanslar",
        "desc": "İnternet bağlantısı olan sistemler için bulut tabanlı doğrulama"
      },
      "offline": {
        "type": "Çevrimdışı Lisanslar",
        "desc": "İnternet erişimi olmayan güvenli ortamlar için dosya tabanlı doğrulama"
      },
      "central": {
        "type": "Merkezi Yönetim",
        "desc": "Tüm lisanslarınızı tek bir panelden yönetebilme imkanı"
      },
      "reporting": {
        "type": "Raporlama",
        "desc": "Detaylı kullanım raporları ve lisans durumu takibi"
      }
    },
    "contact": {
      "sales": {
        "type": "Satış ve Teklif",
        "desc": "Ürünlerimiz hakkında bilgi almak ve teklif talep etmek için"
      },
      "technical": {
        "type": "Teknik Destek",
        "desc": "Kurulum, yapılandırma ve sorun giderme konularında yardım"
      },
      "training": {
        "type": "Eğitim Talepleri",
        "desc": "Profesyonel eğitim programlarımız hakkında bilgi"
      },
      "general": {
        "type": "Genel Sorular",
        "desc": "Şirketimiz ve hizmetlerimiz hakkında genel bilgiler"
      }
    }
  },
  "preferences": {
    "memberSince": "Üyelik başlangıcı",
    "name": "Ad",
    "edit": "Düzenle",
    "resetPassword": "Şifreyi Sıfırla",
    "twoFactorAuth": "İki faktörlü kimlik doğrulama",
    "twoFactorAuthEnabledContent": "Hesabınız için İki Faktörlü Kimlik Doğrulama (2FA) şimdi etkinleştirildi ve oturum açmalarınıza ekstra bir güvenlik katmanı eklendi.",
    "twoFactorAuthDisabledContent": "Hesabınıza ekstra bir güvenlik katmanı ekleyin. Oturum açmak için kullanıcı adınız ve şifrenizle birlikte bir kod sağlamanız gerekecektir.",
    "disable2FA": "2FA'yı devre dışı bırak",
    "setup2FA": "2FA'yı ayarla",
    "emailSubscriptions": "E-posta abonelikleri",
    "manageEmailSubscriptions": "Hangi e-postaları alacağınızı yönetmek için ziyaret edin",
    "notificationSettings": "Bildirim ayarları",
    "editName": "Adı Düzenle",
    "save": "Kaydet",
    "changeNameSuccess": "Adınızı başarıyla değiştirdiniz",
    "oldPassword": "Eski şifre",
    "newPassword": "Yeni şifre",
    "repeatNewPassword": "Yeni şifreyi tekrarla",
    "passwordUniqueChars": "En az 6 benzersiz karakter içermelidir",
    "updatePassword": "Şifreyi Güncelle",
    "changePasswordSuccess": "Şifrenizi başarıyla değiştirdiniz, giriş sayfasına yönlendiriliyorsunuz",
    "oldPasswordIncorrect": "Eski şifre yanlış",
    "oldPasswordRequired": "Eski şifre alanı zorunludur",
    "newPasswordRequired": "Yeni şifre alanı zorunludur",
    "newPasswordCannotBeSame": "Yeni şifre eski şifreyle aynı olamaz",
    "repeatNewPasswordRequired": "Yeni şifreyi tekrarla alanı zorunludur",
    "confirmPasswordNoMatch": "Onay şifresi yeni şifreyle eşleşmiyor"
  },
  "treeView": {
    "basic": "Temel",
    "icons": "İkonlar",
    "selectable": "Seçilebilir",
    "editable": "Düzenlenebilir",
    "advanced": "Gelişmiş"
  },
  "chat": {
    "title": "Sohbet",
    "sendButton": "Gönder"
  },
  "spacingPlayground": {
    "value": "Değer",
    "margin": "Kenar Boşluğu",
    "padding": "Dolgu"
  },
  "spacing": {
    "title": "Boşluk"
  },
  "cards": {
    "cards": "Kartlar",
    "fixed": "Sabit",
    "floating": "Yüzen",
    "contentText": "Zebraların benzersiz çizgileri onları insanların en aşina olduğu hayvanlardan biri yapar.",
    "contentTextLong": "Zebraların benzersiz çizgileri onları insanların en aşina olduğu hayvanlardan biri yapar. Çayırlar, savanlar, ormanlık alanlar, dikenli çalılıklar, dağlar ve kıyı tepeleri gibi çeşitli habitatlarda bulunurlar. Çeşitli insan kaynaklı faktörler, özellikle deri avcılığı ve yaşam alanı yıkımı, zebra popülasyonları üzerinde ciddi bir etkiye sahip olmuştur. Grévy'nin zebrası ve dağ zebrası nesli tükenmektedir. Ova zebraları çok daha bol olmasına rağmen, bir alt tür olan quagga.",
    "rowHeight": "Satır yüksekliği",
    "title": {
      "default": "Varsayılan",
      "withControls": "Kontrollerle",
      "customHeader": "Özel başlık",
      "withoutHeader": "Başlıksız",
      "withImage": "Resimli",
      "withTitleOnImage": "Resim üzerinde başlık",
      "withCustomTitleOnImage": "Resim üzerinde özel başlık",
      "withStripe": "Çizgili",
      "withBackground": "Arka planlı"
    },
    "button": {
      "main": "Ana",
      "cancel": "İptal",
      "showMore": "Daha Fazla Göster",
      "readMore": "Daha Fazla Göster"
    },
    "link": {
      "edit": "Düzenle",
      "setAsDefault": "Varsayılan olarak ayarla",
      "delete": "Sil",
      "traveling": "Seyahat",
      "france": "Fransa",
      "review": "İncele",
      "feedback": "Geri bildirim bırak",
      "readFull": "Tam makaleyi oku",
      "secondaryAction": "İkincil eylem",
      "action1": "Eylem 1",
      "action2": "Eylem 2"
    }
  },
  "colors": {
    "themeColors": "Tema Renkleri",
    "extraColors": "Ekstra Renkler",
    "gradients": {
      "basic": {
        "title": "Düğme Gradyanları"
      },
      "hovered": {
        "title": "Hover Durumu Gradyanları",
        "text": "Hover durumu için orijinal stile (gradyan veya düz renk) %15 açıklık uygulandı."
      },
      "pressed": {
        "title": "Basılı Durum Gradyanları",
        "text": "Basılı durum için orijinal stile (gradyan veya düz renk) %15 koyuluk uygulandı."
      }
    }
  },
  "tabs": {
    "alignment": "Sekme hizalama",
    "overflow": "Sekme taşması",
    "hidden": "Gizli kaydırıcılı sekmeler",
    "grow": "Büyüyen sekmeler"
  },
  "helpAndSupport": "Yardım ve destek",
  "aboutVuesticAdmin": "Vuestic Admin Hakkında",
  "supportAndConsulting": "Destek ve Danışmanlık",
  "search": {
    "placeholder": "Ara..."
  },
  "buttonSelect": {
    "dark": "Koyu",
    "light": "Açık"
  },
  "vuestic": {
    "search": "Ara",
    "noOptions": "Öğe bulunamadı",
    "ok": "Tamam",
    "cancel": "İptal",
    "uploadFile": "Dosya yükle",
    "undo": "Geri al",
    "dropzone": "Yüklemek için dosyaları buraya bırakın",
    "fileDeleted": "Dosya silindi",
    "closeAlert": "uyarıyı kapat",
    "backToTop": "yukarı çık",
    "toggleDropdown": "açılır menüyü değiştir",
    "carousel": "kaydırma",
    "goPreviousSlide": "önceki slayta git",
    "goNextSlide": "sonraki slayta git",
    "goSlide": "{index} numaralı slayta git",
    "slideOf": "{length} slayttan {index} numaralı slayt",
    "close": "kapat",
    "openColorPicker": "renk seçiciyi aç",
    "colorSelection": "renk seçimi",
    "colorName": "{color} rengi",
    "decreaseCounter": "sayacı azalt",
    "increaseCounter": "sayacı artır",
    "selectAllRows": "tüm satırları seç",
    "sortColumnBy": "{name} sütununa göre sırala",
    "selectRowByIndex": "{index} numaralı satırı seç",
    "resetDate": "tarihi sıfırla",
    "nextPeriod": "sonraki dönem",
    "switchView": "görünümü değiştir",
    "previousPeriod": "önceki dönem",
    "removeFile": "dosyayı kaldır",
    "reset": "sıfırla",
    "pagination": "sayfalama",
    "goToTheFirstPage": "ilk sayfaya git",
    "goToPreviousPage": "önceki sayfaya git",
    "goToSpecificPage": "{page} numaralı sayfaya git",
    "goToSpecificPageInput": "gitmek istediğiniz sayfa numarasını girin",
    "goNextPage": "sonraki sayfaya git",
    "goLastPage": "son sayfaya git",
    "currentRating": "mevcut puan {value}/{max}",
    "voteRating": "oy puanı {value}/{max}",
    "optionsFilter": "seçenek filtresi",
    "splitPanels": "panelleri böl",
    "movePaginationLeft": "sayfalamayı sola taşı",
    "movePaginationRight": "sayfalamayı sağa taşı",
    "resetTime": "saati sıfırla",
    "closeToast": "bildirimi kapat",
    "selectedOption": "Seçili seçenek",
    "noSelectedOption": "Seçenek seçilmedi",
    "breadcrumbs": "gezinti",
    "counterValue": "sayaç değeri",
    "selectedDate": "seçili tarih",
    "selectedTime": "seçili saat",
    "progressState": "ilerleme durumu",
    "color": "renk",
    "next": "İleri",
    "back": "Geri",
    "finish": "Bitir",
    "step": "adım",
    "progress": "ilerleme",
    "loading": "Yükleniyor",
    "sliderValue": "Mevcut kaydırıcı değeri {value}",
    "switch": "Anahtar",
    "inputField": "Giriş alanı",
    "fileTypeIncorrect": "Dosya türü yanlış",
    "select": "Bir seçenek seçin"
  },
  "settings": {
    "theme": "Tema",
    "generalPreferences": "Genel tercihler",
    "notificationsYouReceive": "Aldığınız bildirimler"
  },
  "resolutionCenter": {
    "title": "Çözüm Merkezi",
    "description": "Destek taleplerinizi buradan takip edebilirsiniz.",
    "adminTitle": "Yönetici Çözüm Merkezi",
    "adminDescription": "Kullanıcılardan gelen tüm destek taleplerini yönetin ve izleyin.",
    "myTicketsTitle": "Destek Taleplerim",
    "allTicketsTitle": "Tüm Destek Talepleri",
    "createTicketTitle": "Yeni Destek Talebi Oluştur",
    "ticketDetailsTitle": "Talep #{id} - {subject}",
    "openCenter": "Merkezi Aç",
    "createNewTicket": "Yeni Talep Oluştur",
    "viewTicket": "Görüntüle",
    "sendMessage": "Mesaj Gönder",
    "closeTicket": "Talebi Kapat",
    "submitTicket": "Talebi Gönder",
    "cancel": "İptal",
    "backToList": "Listeye Dön",
    "backToMyTickets": "Taleplerime Dön",
    "user": "Kullanıcı",
    "type": "Tür",
    "created": "Oluşturulma",
    "lastUpdate": "Son Güncelleme",
    "messages": "Mesajlar",
    "reply": "Yanıtla",
    "yourReply": "Yanıtınız",
    "noMessagesYet": "Henüz mesaj yok.",
    "typeYourMessage": "Mesajınızı buraya yazın...",
    "ticketClosed": "Bu talep kapatıldı.",
    "ticketStatus": "Bu talep {status} durumunda.",
    "loadingTicket": "Talep detayları yükleniyor veya talep bulunamadı...",
    "noSupportTickets": "Hiç destek talebiniz bulunmamaktadır.",
    "noTicketsFound": "Hiç talep bulunamadı.",
    "ticketNotFound": "Talep bulunamadı.",
    "createFirstTicket": "İlk Talebinizi Oluşturun",
    "subject": "Konu",
    "ticketType": "Talep Türü",
    "priority": "Öncelik",
    "priorityHigh": "Yüksek",
    "priorityMedium": "Orta",
    "priorityLow": "Düşük",
    "typeCustom": "Özel Talep",
    "typeLicense": "Lisans Talebi",
    "describeIssue": "Sorununuzu açıklayın",
    "enterSubject": "Talebiniz için kısa bir konu girin",
    "provideDetails": "Lütfen mümkün olduğunca fazla detay sağlayın...",
    "validationRequired": "Lütfen tüm zorunlu alanları doldurun.",
    "fillAllFields": "Lütfen tüm zorunlu alanları doldurun.",
    "ticketSubmittedSuccess": "Talep başarıyla gönderildi! (Sahte)",
    "ticketCreated": "Talep başarıyla oluşturuldu!",
    "ticketClosedSuccess": "Talep başarıyla kapatıldı.",
    "ticketInProgressSuccess": "Talep devam ediyor olarak işaretlendi.",
    "ticketDevelopingSuccess": "Talep geliştiriciye gönderildi.",
    "messageSentSuccess": "Mesaj başarıyla gönderildi.",
    "errorCreating": "Talep oluşturulurken hata oluştu.",
    "errorFetchingTicket": "Talep detayları alınırken hata oluştu.",
    "errorClosingTicket": "Talep kapatılırken hata oluştu.",
    "errorMarkingTicketAsInProgress": "Talep devam ediyor olarak işaretlenirken hata oluştu.",
    "errorMarkingTicketAsDeveloping": "Talep geliştiriciye gönderilirken hata oluştu.",
    "errorSendingMessage": "Mesaj gönderilirken hata oluştu.",
    "inProgress": "Devam Ediyor Olarak İşaretle",
    "developing": "Geliştiriciye Gönder",
    "statsTotal": "Toplam",
    "statsOpen": "Açık",
    "statsInProgress": "Devam Ediyor",
    "statsDeveloping": "Geliştiricide",
    "statsResolved": "Çözüldü",
    "statsClosed": "Kapalı",
    "statsResolvedOrClosed": "Çözüldü/Kapalı",
    "admin": "Yönetici",
    "support": "Destek",
    "you": "Siz",
    "refresh": "Yenile",
    "export": "Dışa Aktar",
    "view": "Görüntüle",
    "edit": "Düzenle",
    "filter": "Filtrele",
    "sort": "Sırala",
    "loadingTickets": "Talepler yükleniyor...",
    "noTickets": "Destek Talebi Yok",
    "manageMonitorTickets": "Tüm destek taleplerini yönetin ve izleyin",
    "errorFetchingStats": "Talep istatistikleri alınamadı"
  },
  "common": {
    "confirm": "Onayla",
    "copied": "Kod panoya kopyalandı",
    "copyFailed": "Kod kopyalanamadı"
  },
  "pricingPlans": {
    "header": {
      "title": "İşletmeniz İçin Doğru Planı Seçin",
      "subtitle": "Kuruluşunuzun ihtiyaçlarına ve bütçesine en uygun planı seçin"
    },
    "tabs": {
      "custom": "Özel"
    },
    "navigation": {
      "previousPlan": "Önceki plan",
      "nextPlan": "Sonraki plan",
      "goToSlide": "{slideNumber}. slayta git"
    },
    "planCard": {
      "currentPlan": "Mevcut Plan",
      "selectPlan": "Plan Seç",
      "featuresAndBenefits": "Özellikler ve Avantajlar"
    },
    "customPlanCard": {
      "title": "Özel Plan",
      "description": "Tam olarak ihtiyacınız olan özellikleri seçerek kendi planınızı oluşturun",
      "customizePlan": "Planı Özelleştir",
      "benefitsTitle": "Özel Plan Avantajları",
      "benefitChooseFeatures": "Sadece ihtiyacınız olan özellikleri seçin",
      "benefitPayForUse": "Sadece kullandığınız kadar ödeyin",
      "benefitFlexible": "Büyüyen işletmeler için esnek",
      "benefitScalable": "İhtiyaçlarınız değiştikçe ölçeklendirin",
      "selectedTitle": "Özel Plan Seçildi",
      "selectedMessage": "Özel planı seçtiniz. Özellik seçimine devam etmek için aşağıya tıklayın.",
      "proceedButton": "Özelleştirmeye Devam Et",
      "contactTitle": "Destek ile İletişim",
      "contactMessage": "Özel plan gereksinimlerinizi görüşmek ve kişiselleştirilmiş fiyatlandırma almak için lütfen bizimle iletişime geçin."
    },
    "actions": {
      "continueWithPlan": "{planName} ile Devam Et"
    },
    "notifications": {
      "loadFailed": "Fiyatlandırma planları yüklenemedi. Lütfen daha sonra tekrar deneyin.",
      "planChangeSuccess": "Ödeme planınızı başarıyla değiştirdiniz!",
      "customPlanSelected": "Özel plan seçildi. Şimdi özelliklerinizi seçebilirsiniz.",
      "planDetailsNotFound": "Seçilen plan detayları bulunamadı."
    },
    "modal": {
      "confirmPlanChange": {
        "title": "Plan Değişikliğini Onayla",
        "message": "Planınızı değiştirmek istediğinizden emin misiniz?"
      }
    },
    "plan": {
      "descriptionSuffix": "ihtiyaçlarınız için Plan"
    }
  },
  "payments": {
    "title": "Ödeme Yöntemleri",
    "myCards": "Kartlarım",
    "billingAddress": "Fatura Adresi",
    "taxLocation": "Vergi Konumu",
    "taxInfo": "Türkiye - %20 KDV",
    "moreInfo": "Daha fazla bilgi",
    "enterprise": {
      "header": {
        "title": "Kurumsal Ödeme İşlemleri",
        "subtitle": "Güvenli • Kişiselleştirilmiş • Profesyonel"
      },
      "manual": {
        "title": "Manuel Ödeme Sistemi",
        "description": "Gelişmiş güvenlik ve kişiselleştirilmiş hizmet için şu anda manuel ödeme işleme sistemi ile çalışmaktayız. Kurumsal destek ekibimiz, özel iş ihtiyaçlarınızın karşılanmasını sağlamak için tüm ödeme sürecinde size rehberlik edecektir."
      },
      "whyManual": {
        "title": "Neden Manuel İşlem?",
        "security": "İnsan doğrulaması ile gelişmiş güvenlik",
        "customized": "Özelleştirilmiş kurumsal çözümler",
        "support": "Karmaşık gereksinimler için doğrudan destek",
        "flexible": "Esnek ödeme koşulları ve faturalandırma"
      },
      "contact": {
        "title": "Kurumsal Destek İletişim",
        "phone": {
          "label": "Direkt Hat",
          "number": "0850 460 10 58",
          "hours": "Çalışma Saatleri: 09:00 - 18:00"
        },
        "email": {
          "label": "Kurumsal Satış",
          "addressPrefix": "info",
          "addressSuffix": "rakort.com",
          "response": "2 saat içinde yanıt"
        }
      },
      "process": {
        "title": "Ödeme Süreci",
        "step1": "Kurumsal ekibimizle iletişime geçin",
        "step2": "Gereksinimler ve fiyatlandırmayı görüşün",
        "step3": "Güvenli ödeme işlemi",
        "step4": "Anında hizmet aktivasyonu"
      },
      "actions": {
        "callSupport": "Kurumsal Desteği Arayın",
        "sendInquiry": "Talep Gönderin",
        "emailSubject": "Kurumsal Ödeme Talebi"
      },
      "footer": {
        "note": "* Yukarıdaki kart yönetim arayüzü ödeme kurulumu tamamlandıktan sonra kullanılabilir olacaktır"
      },
      "trust": {
        "security": "Kurumsal Güvenlik",
        "support": "7/24 Destek",
        "solutions": "Özel Çözümler"
      }
    }
  },
  "mfaAuthenticator": {
    "title": "MFA Doğrulayıcı",
    "description": "Çok Faktörlü Kimlik Doğrulama kodlarınızı yönetin ve izleyin",
    "currentCode": {
      "title": "Güncel TOTP Kodu",
      "label": "Doğrulama Kodu",
      "timeRemaining": "Kalan Süre",
      "nextRefresh": "Sonraki Yenileme",
      "refresh": "Kodu Yenile"
    },
    "verification": {
      "title": "Kod Doğrulama",
      "codeLabel": "TOTP Kodunu Girin",
      "codePlaceholder": "123456",
      "verify": "Kodu Doğrula",
      "required": "Kod gereklidir",
      "success": "Kod Doğrulandı",
      "failed": "Doğrulama Başarısız",
      "successMessage": "TOTP kodu başarıyla doğrulandı"
    },
    "settings": {
      "title": "MFA Ayarları",
      "status": "MFA Durumu",
      "enabled": "Çok Faktörlü Kimlik Doğrulama etkin",
      "disabled": "Çok Faktörlü Kimlik Doğrulama devre dışı",
      "qrCode": "QR Kod Kurulumu",
      "qrInstructions": "Bu QR kodunu doğrulayıcı uygulamanızla tarayın (Google Authenticator, Authy, vb.)",
      "generateNew": "Yeni QR Kod Oluştur",
      "qrNotActivated": "QR Aktif Değil",
      "contactAdminForQr": "QR kod kurulumunu aktifleştirmek için sistem yöneticinizle iletişime geçin",
      "contactAdmin": "Yöneticiyle İletişim"
    },
    "admin": {
      "title": "Yönetim Bildirimi",
      "description": "QR kod aktivasyonu, gelişmiş ayarlar veya teknik destek için sistem yöneticinizle iletişime geçin.",
      "contactSupport": "Destek İle İletişim"
    },
    "errors": {
      "fetchFailed": "Güncel MFA kodu alınamadı",
      "verificationFailed": "MFA kodu doğrulanamadı",
      "provisioningFailed": "Kurulum verileri oluşturulamadı"
    }
  },
  "updates": {
    "title": "Güncellemeler",
    "description": "Güncellemeleri yönetin ve izleyin",
    "add_new": "Yeni Güncelleme Ekle",
    "step_1": "Adım 1: Dosyaları Yükleyin",
    "step_2": "Adım 2: Komutları Girin",
    "backend_files": "Backend Dosyası",
    "frontend_files": "Frontend Dosyası",
    "other_files": "Ek Dosyalar (İsteğe Bağlı)",
    "other_files_error": "Lütfen her ek dosya için bir yol sağlayın.",
    "version": "Sürüm",
    "change_log": "Değişiklik Logu",
    "type": "Tip",
    "time": "Zaman",
    "failed_to_load_updates": "Güncellemeler yüklenemedi: Geçersiz veri formatı.",
    "backend_file_error": "Dosya adı backend.zip olmalıdır",
    "frontend_file_error": "Dosya adı frontend.zip olmalıdır",
    "please_select_both_files": "Lütfen hem backend hem de frontend dosyalarını seçin.",
    "files_uploaded_successfully": "Dosyalar başarıyla yüklendi!",
    "failed_to_upload_files": "Dosyalar yüklenemedi: ",
    "commands_sent_successfully": "Komutlar başarıyla gönderildi!",
    "failed_to_send_commands": "Komutlar gönderilemedi: ",
    "go_back": "Geri",
    "next": "İleri",
    "finish": "Bitir",
    "upload_files": "Dosyaları Yükle",
    "please_wait_while_files_are_uploading": "Dosyalar yüklenirken lütfen bekleyin",
    "enter_commands": "Komutları Girin",
    "add_command": "Komut Ekle",
    "finish_process": "Güncelleme Süreci Tamamlandı",
    "command": "Komut",
    "all_steps_completed_successfully": "Tüm adımlar başarıyla tamamlandı!",
    "update_files_uploaded_and_commands_sent": "Güncelleme dosyaları yüklendi ve komutlar gönderildi. Bu iletişim kutusunu kapatabilirsiniz.",
    "step_3_success": "Güncelleme dosyaları yüklendi ve komutlar gönderildi. Bu iletişim kutusunu kapatabilirsiniz.",
    "header_placeholder": "Değişiklik logunuzu giriniz.",
    "step_3": "Adım 3: Değişiklik Logu Girin",
    "header": "Başlık",
    "change_log_placeholder": "Değişiklik logunuzu giriniz.",
    "major": "Major (Kapsamlı)",
    "minor": "Minor (Az Kapsamlı)",
    "version_placeholder": "Sürüm numarasını giriniz",
    "failed_to_send_step3": "Adım 3 gönderilemedi: ",
    "step3_required_fields": "Lütfen tüm alanları doldurun",
    "step3_success": "Veriler başarıyla gönderildi.",
    "refresh": "Yenile",
    "verified": "Doğrulandı",
    "not_verified": "Doğrulanmadı",
    "partially_verified": "Kısmen Doğrulandı",
    "is_verified": "Doğrulama Durumu",
    "verify": "Doğrula",
    "actions": "İşlemler",
    "username": "Kullanıcı Adı",
    "user_verified_successfully": "Kullanıcı başarıyla doğrulandı",
    "customer_update_history": "Müşteri Güncelleme Geçmişi",
    "license_key": "Lisans Anahtarı",
    "customer": "Müşteri",
    "search_customer": "Müşteri ara...",
    "search_version": "Versiyon ara...",
    "search_license_key": "Lisans anahtarı ara...",
    "clear_filters": "Filtreleri Temizle",
    "license_key_copied": "Lisans anahtarı kopyalandı!",
    "fileUpload": {
      "description": ".req dosyalarınızı buradan okuyabilirsiniz (Maksimum 500KB, en az 2 satır)",
      "dragDropTitle": ".req dosyasını buraya sürükleyin",
      "dragDropSubtitle": "veya .req dosyası seçmek için tıklayın",
      "selectFileButton": ".req Dosyası Seç",
      "selectedFile": "Seçilen Dosya",
      "fileContent": "Dosya İçeriği",
      "fileContentLines": "satır",
      "authLine": "Auth Satırı (İlk Satır):",
      "authLinePlaceholder": "Auth bilgisi buraya gelecek",
      "allLines": "Tüm Satırlar:",
      "processFile": "Dosyayı İşle",
      "processing": "İşleniyor...",
      "fileSizeLimit": "Dosya boyutu 500KB'dan büyük olamaz",
      "fileExtensionError": "Lütfen sadece .req uzantılı dosya seçin",
      "minLinesError": "Dosya en az 2 satır içermelidir (1. satır: lic_key, 2. satır: data)",
      "minLinesErrorShort": "Dosya en az 2 satır içermelidir",
      "selectFileError": "Lütfen bir .req dosyası seçin",
      "authRequestFailed": "Auth isteği başarısız: ",
      "listRequestFailed": "List isteği başarısız: ",
      "requestsCompleted": "İstekler başarıyla tamamlandı!",
      "requestError": "İstek hatası: ",
      "unknownError": "Bilinmeyen hata",
      "tableTitle": "Güncelleme Listesi",
      "version": "Versiyon",
      "changeLog": "Değişiklik Günlüğü",
      "type": "Tip",
      "download": "İndir",
      "downloadable": "İndirilebilir",
      "notDownloadable": "İndirilemez",
      "upToDate": "En güncel sürümdesiniz! 🎉",
      "noData": "Cihazınız en güncel sürümde. Herhangi bir güncelleme bulunmuyor.",
      "downloading": "İndiriliyor...",
      "downloadSuccess": "Dosya başarıyla indirildi: ",
      "downloadFailed": "İndirme başarısız: ",
      "downloadError": "İndirme hatası: "
    }
  },
  "licenseStatus": {
    "active": "Aktif",
    "notActivated": "Aktif Değil",
    "deactivated": "Devre Dışı"
  },
  "threatIntelligence": {
    "title": "Gerçek Zamanlı Tehdit İstihbaratı",
    "search": "Zafiyetleri ara...",
    "vulnerabilities": "Bilinen Zafiyetler",
    "available": "Mevcut",
    "pending": "Bekliyor",
    "fixedVersion": "Düzeltilen Versiyon"
  }
}
